if (!customElements.get('deployer-cart-discount')) {
    customElements.define(
        'deployer-cart-discount',

        class DeployerCartDiscount extends HTMLElement {
            constructor() {
                super();
                this.applyButton = this.querySelector('.deployer-cart-discount_button');
                this.input = this.querySelector('.deployer-cart-discount_input');
                //Connect Listeners
                this.applyButton.addEventListener('click', this.submitDiscount.bind(this));
                this.querySelector('.cart-discount__remove-discount').addEventListener('click', this.removeDiscount.bind(this));
                this.addEventListener('discount:remove', this.removeDiscount.bind(this));
                if (this.querySelector('.deployer-cart-discount_auto-add-product')) this.handleAutoAddProduct();
            }

            async submitDiscount(event) {
                event.preventDefault();
                this.applyButton.disabled = true;
                if (localStorage.getItem('discountCode') != null) {
                    this.removeDiscount();
                    return;
                }
                const discountCode = this.input.value;
                if (discountCode === '') {
                    this.setErrorMode('Veuillez saisir un code');
                } else {
                    this.applyCode(discountCode);
                }
            }

            async removeDiscount() {
                if (this.querySelector('.cart-discount_badge').classList.contains('loading')) return;
                this.setButtonLoading();
                this.querySelector('.cart-discount_badge').classList.add('loading');
                localStorage.removeItem('discountCode');
                await fetch('/discount/CLEAR');
                setTimeout(() => {
                    this.updateCart(null);
                    this.setButtonLoaded();
                }, 200);
            }

            async applyCode(discountCode) {
                this.setButtonLoading();
                fetch('/payments/config', { method: 'GET' })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(
                        function (data) {
                            const checkout_json_url = '/wallets/checkouts/';
                            let authorization_token = btoa(data.paymentInstruments.accessToken);
                            fetch(window.Shopify.routes.root + 'cart.js', {})
                                .then(function (res) {
                                    return res.json();
                                })
                                .then(
                                    function (data) {
                                        let body = {
                                            checkout: {
                                                country: Shopify.country,
                                                discount_code: discountCode,
                                                line_items: data.items,
                                                presentment_currency: Shopify.currency.active,
                                            },
                                        };
                                        fetch(checkout_json_url, {
                                            headers: {
                                                accept: '*/*',
                                                'cache-control': 'no-cache',
                                                authorization: 'Basic ' + authorization_token,
                                                'content-type': 'application/json, text/javascript',
                                                pragma: 'no-cache',
                                                'sec-fetch-dest': 'empty',
                                                'sec-fetch-mode': 'cors',
                                                'sec-fetch-site': 'same-origin',
                                            },
                                            referrerPolicy: 'strict-origin-when-cross-origin',
                                            method: 'POST',
                                            mode: 'cors',
                                            credentials: 'include',
                                            body: JSON.stringify(body),
                                        })
                                            .then(function (response) {
                                                return response.json();
                                            })
                                            .then(
                                                async function (data) {
                                                    if (data.checkout && data.checkout.applied_discounts.length > 0) {
                                                        let d = data.checkout.applied_discounts.find((d) => d.title.toUpperCase() === discountCode.toUpperCase());
                                                        if (d) {
                                                            let discountApplyUrl = '/discount/' + discountCode;
                                                            await fetch(discountApplyUrl, {}).then(function (response) {
                                                                return response.text();
                                                            });
                                                            let localStorageValue = {
                                                                code: d.title.trim(),
                                                                totalCart: data.checkout.total_line_items_price,
                                                            };
                                                            localStorage.setItem('discountCode', JSON.stringify(localStorageValue));
                                                            setTimeout(() => {
                                                                this.updateCart(discountCode + '=' + d.amount);
                                                                this.setButtonLoaded();
                                                            }, 500);
                                                        } else {
                                                            this.setErrorMode();
                                                            this.removeDiscount();
                                                        }
                                                    } else {
                                                        this.setErrorMode();
                                                        this.removeDiscount();
                                                    }
                                                }.bind(this)
                                            )
                                            .finally(() => { })
                                            .catch((e) => {
                                                console.error(e);
                                                this.setErrorMode('Une erreur est survenue');
                                            });
                                    }.bind(this)
                                );
                        }.bind(this)
                    );
            }

            setErrorMode(message = 'Veuillez saisir un code valide') {
                // Reset the button state
                this.applyButton.disabled = false;
                this.applyButton.classList.remove('deployer-button--is-loading');
                // Set the input in error mode
                this.input.focus();
                this.input.classList.add('deployer-cart-discount_input-error');
                this.input.placeholder = message;
                this.input.value = '';
                setTimeout(() => {
                    this.input.classList.remove('deployer-cart-discount_input-error');
                    this.input.placeholder = this.input.dataset.defaultPlaceholder;
                }, 2000);
            }

            setButtonLoading() {
                this.applyButton.disabled = true;
                this.applyButton.classList.add('deployer-button--is-loading');
            }

            setButtonLoaded() {
                this.applyButton.disabled = false;
                this.applyButton.classList.remove('deployer-button--is-loading');
            }

            async updateCart(discount) {
                return await fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        attributes: {
                            discount: discount,
                        },
                        sections: 'deployer-cart-drawer',
                        sections_url: window.location.pathname,
                    }),
                }).then(() => {
                    // Deployer Cart Drawer
                    document.dispatchEvent(new CustomEvent('deployer-cart-drawer:refresh'));

                    // Cart Drawer Thème Impact & Prestige
                    document.documentElement.dispatchEvent(
                        new CustomEvent('cart:refresh', {
                            bubbles: true,
                        })
                    );

                    // Cart page
                    if (window.location.pathname.includes('/cart')) {
                        window.location.reload();
                    }

                    // Generic Cart Drawer Refresh -> Si le thème n'a pas de fonction ou d'évenement pour rafraichir le panier
                    // const cartDrawerSection = deployerAdapter.cartDrawerSection || 'cart-drawer'; //shopify-section-cart-drawer = cart-drawer
                    // const cartDrawerWebComponent = deployerAdapter.cartDrawerWebComponent || 'cart-drawer';
                    // fetch(window.Shopify.routes.root + '?sections=' + cartDrawerSection)
                    //   .then((res) => res.json())
                    //   .then((data) => {
                    //     document.querySelector(cartDrawerWebComponent).innerHTML = new DOMParser().parseFromString(data[cartDrawerSection], 'text/html').querySelector(cartDrawerWebComponent).innerHTML;
                    //   });
                });
            }

            handleAutoAddProduct() {
                const discount_prefix = this.querySelector('.deployer-cart-discount_auto-add-product').dataset.prefix.toLowerCase();
                const product_to_add = this.querySelector('.deployer-cart-discount_auto-add-product').dataset.productToAdd;
                var product_already_in_cart = false;
                fetch('/cart.js')
                    .then((response) => response.json())
                    .then((data) => {
                        data.items.forEach((item) => {
                            if (item.id == product_to_add) {
                                product_already_in_cart = true;
                            }
                        });
                    })
                    .then(() => {
                        if (localStorage.getItem('discountCode') == null || product_already_in_cart) return;
                        const discount_code = JSON.parse(localStorage.getItem('discountCode')).code.toLowerCase();
                        if (discount_code.includes(discount_prefix)) {
                            fetch('/cart/add.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    items: [
                                        {
                                            id: product_to_add,
                                            quantity: 1,
                                        },
                                    ],
                                }),
                            }).then(() => {
                                document.dispatchEvent(new CustomEvent('deployer-cart-drawer:refresh'));
                            });
                        }
                    });
            }
        }
    );
}